export default "__VITE_ASSET__Dg6biLi$__"